// Module
var code = `<h2 class="section-header">Loan batch payment upload</h2>

<form name="\$ctrl.form" novalidate>
  <table class="table table--generate-row-ids">
    <tbody>
      <tr>
        <td></td>
        <td>Payment type:</td>
        <td>
          <select name="paymentMethod"
                  class="form-control"
                  ng-model="\$ctrl.payment.paymentMethod"
                  ng-options="paymentMethod.value as paymentMethod.label for paymentMethod in \$ctrl.paymentMethods"
                  ng-change="\$ctrl.paymentMethodChanged()"
                  required>
          </select>
        </td>
      </tr>
      <tr ng-if="\$ctrl.payment.paymentMethod === 'MEMO'">
        <td></td>
        <td>GL category:</td>
        <td>
          <gl-category-select
              required
              ng-model="\$ctrl.category"
              action-type="'LOAN_BATCH_GL_PAYMENT'"
              single-accounts-only="true"
              is-selectize="true"
              ng-change="\$ctrl.categoryChanged()"
          >
          </gl-category-select>
        </td>
      </tr>
      <tr ng-if="\$ctrl.payment.paymentMethod === 'MEMO'">
        <td></td>
        <td>Account:</td>
        <td>
          <input type="text" disabled ng-value="\$ctrl.category.ledgerAccountFullCodes[0]" />
        </td>
      </tr>
      </gl-category-input>
      <tr ng-if="\$ctrl.payment.paymentMethod === 'TRANSFER'">
        <td></td>
        <td>Account number:</td>
        <td>
          <input name="accountNumber"
                 class="form-control"
                 ng-model="\$ctrl.payment.accountNumber"
                 type="text"
                 ng-change="\$ctrl.clearSimulation()"
                 required/>
        </td>
      </tr>
      <tr ng-if="!\$ctrl.autoOfficialReceiptEnabled">
        <td></td>
        <td>Invoice:</td>
        <td>
          <input name="officialReceipt"
                 class="form-control"
                 ng-model="\$ctrl.payment.officialReceipt"
                 type="text"
                 ng-change="\$ctrl.clearSimulation()"
                 required/>
        </td>
      </tr>
      <tr ng-if="\$ctrl.autoOfficialReceiptEnabled">
        <td></td>
        <td>Invoice start:</td>
        <td>
          <input name="officialReceiptStart"
                 class="form-control"
                 ng-if="\$ctrl.officialReceiptStart"
                 ng-model="\$ctrl.officialReceiptStart"
                 type="text"
                 disabled
                 required/>
          <div class="alert alert--danger" ng-if="!\$ctrl.officialReceiptStart">
            User has no available invoice!
          </div>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Remarks:</td>
        <td>
          <input
            type="text"
            ng-model="\$ctrl.payment.remarks"
            ng-change="\$ctrl.clearSimulation()"
          />
        </td>
      </tr>
      <tr>
        <td></td>
        <td>File:</td>
        <td>
          <file-id-upload
            single-file="true"
            ng-model="\$ctrl.payment.attachedFileId"
            validate="{pattern: '.csv,*.txt', size: { max: '5MB'}}"
            enable-webcam="false"
            max-files="1"
            show-remarks="false"
            ng-change="\$ctrl.clearSimulation()"
            required
          >
          </file-id-upload>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>File Type:</td>
        <td>
          <select name="fileType"
                  class="form-control"
                  ng-model="\$ctrl.payment.fileType"
                  ng-options="fileType.value as fileType.label for fileType in \$ctrl.fileTypes"
                  ng-change="\$ctrl.clearSimulation()"
                  required>
          </select>
        </td>
      </tr>
      <tr ng-if="\$ctrl.requiresSeparator()">
        <td></td>
        <td>CSV Separator:</td>
        <td>
          <select name="csvSeparator"
                  class="form-control"
                  ng-model="\$ctrl.payment.csvSeparator"
                  ng-options="csvSeparator.code as csvSeparator.label for csvSeparator in \$ctrl.csvSeparators"
                  ng-change="\$ctrl.clearSimulation()"
                  required>
          </select>
        </td>
      </tr>
      <tr ng-if="\$ctrl.valueDateEnabled">
        <td></td>
        <td>Value Date:</td>
        <td>
          <value-date ng-model="\$ctrl.payment.valueDate"></value-date>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Skip simulation:
          <help title="Skipping simulation improves performance. If a payment fails during processing it will be skipped and the remaining rows of the file will be processed." ></help>
        </td>
        <td>
          <select required
                  name="skipSimulation"
                  boolean-options
                  ng-change="\$ctrl.clearSimulation()"
                  ng-model="\$ctrl.skipSimulation">
          </select>
        </td>
      </tr>
    </tbody>
  </table>

  <div ng-if="\$ctrl.simulation">
    <h2 class="section-header">File summary</h2>

    <div ng-if="\$ctrl.simulation.perRowFormatErrors.length > 0">
      <validator condition="false"></validator>

      <div class="alert alert--danger file-error-alert" >
        File has format errors:
      </div>

      <dynamic-list
        columns="\$ctrl.formatErrorColumns"
        data="\$ctrl.simulation.perRowFormatErrors"
        list-type="'ERROR'"
        generate-row-ids="false"
      >
      </dynamic-list>
    </div>

    <div ng-if="\$ctrl.simulation.perRowBusinessErrors.length > 0">
      <validator condition="false"></validator>

      <div class="alert alert--danger file-error-alert" >
        File has payment errors:
      </div>

      <dynamic-list
        columns="\$ctrl.simulation.businessErrorColumns"
        data="\$ctrl.simulation.perRowBusinessErrors"
        list-type="'ERROR'"
        generate-row-ids="false"
      >
      </dynamic-list>
    </div>

    <div ng-if="\$ctrl.simulation.perRowSuccessfulPayments.length > 0">
      <div class="alert file-error-alert" >
        Valid rows:
      </div>

      <dynamic-list
        columns="\$ctrl.simulation.successfulColumns"
        data="\$ctrl.simulation.perRowSuccessfulPayments"
        generate-row-ids="false"
      >
      </dynamic-list>
    </div>
  </div>

  <div class="summary-actions">
    <button
        type="button"
        class="btn btn-info"
        ng-click="\$ctrl.downloadSampleFile()">
      Download sample file
    </button>
    <button
        type="button"
        class="btn btn-warning"
        ng-click="\$ctrl.resetForm()">
      Clear form
    </button>
    <button
      ng-if="!\$ctrl.simulation && !\$ctrl.skipSimulation"
      type="button"
      class="btn btn-success"
      ng-click="\$ctrl.simulatePayment()"
      ng-disabled="\$ctrl.form.\$invalid">
      Upload file
    </button>
    <button
        ng-if="\$ctrl.simulation || \$ctrl.skipSimulation"
        type="button"
        class="btn btn-success"
        ng-click="\$ctrl.submitPayment()"
        ng-disabled="\$ctrl.form.\$invalid">
      Submit payment
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/loan-payment/batch-loan-payments-upload.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;